import { useState, useRef, useEffect } from "react";
import NotificationItem from "./NotificationItem";
import NotificationAPI from "../../services/notification";
import FireBaseService from "../../services/fireBase";
import TokenService from "../../services/token.service";
import { toast } from "react-toastify";
import { CustomToast } from "./fireBaseNotification";
import { useNotification } from "../../context/NotificationContext";
import dayjs from "dayjs";

const groupNotificationsByDate = (notifications) => {
  const today = dayjs();
  const yesterday = dayjs().subtract(1, "day");

  const grouped = {
    today: [],
    yesterday: [],
    older: [],
  };

  notifications.forEach((noti) => {
    const addedDate = dayjs(noti.addedat);

    if (addedDate.isSame(today, "day")) {
      grouped.today.push(noti);
    } else if (addedDate.isSame(yesterday, "day")) {
      grouped.yesterday.push(noti);
    } else {
      grouped.older.push(noti);
    }
  });

  return grouped;
};

const NotificationDropdown = ({ setShow }) => {
  const { count } = useNotification();
  const { getStorageData, rememberGet } = TokenService();
  const { getNotifications } = NotificationAPI();
  const { onMessageListener } = FireBaseService();
  const myData = getStorageData(rememberGet());
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [notiCheck, setNotiCheck] = useState(false);
  const scrollContainerRef = useRef(null);
  const grouped = groupNotificationsByDate(notifications);

  const fetchNotifications = async (pageNum) => {
    setLoading(true);
    try {
      const response = await getNotifications(pageNum);
      setNotifications((prev) => [...prev, ...response?.data?.data]);
      setHasMore(response?.data?.pagination?.nextPage);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (myData) {
      fetchNotifications(1);
    }
    // }, [notiCheck, myData]);
    // eslint-disable-next-line
  }, [count]);

  // useEffect(() => {
  //   reset();
  //   // eslint-disable-next-line
  // }, []);

  const handleScroll = () => {
    if (!scrollContainerRef.current || loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchNotifications(nextPage);
    }
  };

  useEffect(() => {
    const unsubscribe = onMessageListener()
      .then((payload) => {
        setNotiCheck((prev) => !prev);
        setShow(1);
        const title =
          payload.notification?.title ||
          payload.data?.title ||
          "New Notification";
        const body =
          payload.notification?.body ||
          payload.data?.body ||
          "You have a new message.";

        toast.info(<CustomToast title={title} body={body} />, {
          position: "top-center",
          autoClose: 5000,
        });
      })
      .catch((err) => {
        console.error("Notification error: ", err);
      });

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <ul
      className="dropdown-menu dropdown-menu-end p-0"
      style={{ minWidth: "300px", maxHeight: "400px" }}
    >
      <li className="dropdown-header p-2 border-bottom bg-white group-title">
        Notifications
      </li>

      <div
        ref={scrollContainerRef}
        onScroll={handleScroll}
        style={{ maxHeight: "350px", overflowY: "auto" }}
      >
        {grouped.today.length > 0 && (
          <>
            <li className="group-title">Today</li>
            {grouped.today.map((val, ind) => (
              <NotificationItem key={ind} val={val} today={true} />
            ))}
          </>
        )}

        {grouped.yesterday.length > 0 && (
          <>
            <li className="group-title">Yesterday</li>
            {grouped.yesterday.map((val, ind) => (
              <NotificationItem key={ind} val={val} />
            ))}
          </>
        )}

        {grouped.older.length > 0 && (
          <>
            <li className="group-title">Older</li>
            {grouped.older.map((val, ind) => (
              <NotificationItem key={ind} val={val} />
            ))}
          </>
        )}

        {loading && (
          <li className="p-2 text-center">
            <div className="spinner-border spinner-border-sm" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </li>
        )}

        {!hasMore && notifications.length > 0 && (
          <li className="p-2 text-muted text-center small">
            No more notifications
          </li>
        )}
      </div>
    </ul>
  );
};

export default NotificationDropdown;
